<template>
  <div 
    class="mt-8 px-5">
    <v-layout wrap>
      <v-flex>
        <section>

          <v-row
            class="">
            <v-col 
              cols="12"
              class="py-0">
              <v-card 
                flat
                style="border-radius: 6px; border: 1px solid #E7E7E7;">
                <v-card-text
                  v-if="process.load" 
                  class="pb-0 my-4" style="height: 500px; display: flex; align-items: center; justify-content: center;">
                  <div class="text-center">
                    <div class="mb-2 title">
                      Mohon Tunggu...
                    </div>
                    <v-progress-circular
                      indeterminate
                    ></v-progress-circular>
                  </div>
                </v-card-text>

                <v-card-text v-if="!process.load && Object.keys(detail).length > 0">
                  <!-- <div class="black--text fs-18 font-weight-bold mb-3">
                    Detail Promo
                  </div> -->
                  <v-card 
                    flat
                    class="mb-5">

                    <div class="fs-18 font-weight-bold black--text ">
                      Informasi Promo
                    </div>
                    <!-- <v-card-text> -->
                      <v-row>
                        <v-col cols="12" md="12">
                          <v-card 
                            flat
                            class="mb-5"
                            style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
                            <v-card-text>
                              <table style="width: auto; border: none;">
                                <tr>
                                  <td style="border: none; padding: 2px 4px;" class="black--text ">
                                    Nama Promo
                                  </td>
                                  <td style="width: 40px; border: none; padding: 2px 4px;" class="black--text text-center">
                                    : 
                                  </td>
                                  <td style="border: none; padding: 2px 4px;" class="black--text text-left font-weight-bold">
                                    {{ detail.title }}
                                  </td>
                                </tr>
                                <tr>
                                  <td style="border: none; padding: 2px 4px;" class="black--text ">
                                    Kategori
                                  </td>
                                  <td style="width: 40px; border: none; padding: 2px 4px;" class="black--text text-center">
                                    : 
                                  </td>
                                  <td class="black--text text-left font-weight-bold" style="border: none; padding: 2px 4px;">
                                    {{ detail.category === 'area' ? 'Area' : detail.category === 'kode_sales' ? 'Kode Sales' : 'Tipe Toko' }}
                                  </td>
                                </tr>
                                <tr>
                                  <td style="border: none; padding: 2px 4px;" class="black--text ">
                                    Nama {{ detail.category === 'area' ? 'Area' : detail.category === 'kode_sales' ? 'Kode Sales' : 'Tipe Toko' }}
                                  </td>
                                  <td style="width: 40px; border: none; padding: 2px 4px;" class="black--text text-center">
                                    : 
                                  </td>
                                  <td class="black--text text-left font-weight-bold" style="border: none; padding: 2px 4px;">
                                    <div v-if="detail.category === 'area'">
                                      {{ detail.province_name }} <span v-if="detail.city_id !== '0'">- {{ detail.city_name }}</span> <span v-if="detail.sub_district_id !== '0'">- {{ detail.sub_district_name }}</span>
                                    </div>
                                    <div v-if="detail.category === 'kode_sales'">
                                      {{ detail.sales_region_name }}
                                    </div>
                                  </td>
                                </tr>
                                <!-- <tr>
                                  <td style="border: none; padding: 2px 4px;" class="black--text ">
                                    Nama Toko
                                  </td>
                                  <td style="width: 40px; border: none; padding: 2px 4px;" class="black--text text-center">
                                    : 
                                  </td>
                                  <td class="black--text text-left font-weight-bold" style="border: none; padding: 2px 4px;">
                                    <div class="d-flex align-center" style="width: 100%; flex-wrap: wrap;">
                                      <div v-for="(item, index) in detail.promo_store" :key="index" >
                                        <v-chip
                                          class="ma-1"
                                          color="primary"
                                          small
                                          label
                                          style="font-size: 12px;">
                                          {{ item.store_name }} - {{ item.customer_name }}
                                        </v-chip>
                                      </div>
                                    </div>
                                  </td>
                                </tr> -->
                                <tr>
                                  <td style="border: none; padding: 2px 4px; min-width: 130px; width: 130px; max-width: 130px;" class="black--text ">
                                    Nama Produk
                                  </td>
                                  <td style="width: 40px; border: none; padding: 2px 4px;" class="black--text text-center">
                                    : 
                                  </td>
                                  <td class="black--text text-left font-weight-bold" style="border: none; padding: 2px 4px;">
                                    {{ detail.product_varian_name }}
                                  </td>
                                </tr>
                                <tr>
                                  <td style="border: none; padding: 2px 4px;" class="black--text ">
                                    Tanggal Promo
                                  </td>
                                  <td style="width: 40px; border: none; padding: 2px 4px;" class="black--text text-center">
                                    : 
                                  </td>
                                  <td class="black--text text-left font-weight-bold" style="border: none; padding: 2px 4px;">
                                    {{ detail.start_date | date }} - {{ detail.end_date | date }}
                                  </td>
                                </tr>
                                <tr>
                                  <td style="border: none; padding: 2px 4px;" class="black--text ">
                                    Deskripsi Promo
                                  </td>
                                  <td style="width: 40px; border: none; padding: 2px 4px;" class="black--text text-center">
                                    : 
                                  </td>
                                  <td class="black--text text-left font-weight-bold" style="border: none; padding: 2px 4px;">
                                    {{ detail.desc }}
                                  </td>
                                </tr>
                              </table>  
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                    <!-- </v-card-text> -->
                  </v-card>


                  <v-card 
                    flat
                    class="mb-5">

                    <div class="fs-18 font-weight-bold black--text ">
                      Tipe & Syarat Ketentuan Promo
                    </div>

                    <v-row>
                      <v-col cols="12" md="12">
                        <v-row>
                          <v-col cols="12" md="12">
                            <v-card
                              flat
                              style="border-radius: 10px; background-color: #FFE0B2">
                              <v-card-text>
                                <div class="black--text mb-1">
                                  {{ detail.value_qty === 'value' ? 'Nominal' : 'Kuota' }}
                                </div>
                                <div class="black--text fs-20 font_weight_600 black_one">
                                  <span v-if="detail.value_qty === 'value'">Rp. </span> {{ (detail.quota*1) | number }} <span v-if="detail.value_qty === 'qty'">{{ detail.quota_unit }}</span>
                                </div>
                              </v-card-text>
                            </v-card>  
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" :md="(detail.bonus_qty*1) > 0 ? 6 : 4" class="black--text py-0">
                        <v-row>
                          <v-col cols="12" md="12">
                            <v-card
                              flat
                              style="border-radius: 10px; background-color: #B3E5FC">
                              <v-card-text>
                                <div class="black--text mb-1">
                                  Syarat & Ketentuan
                                </div>
                                <div class="black--text fs-20 font_weight_600 black_one">
                                  {{ detail.minimum_transaksi !== '0' ? 'Gunakan Minimal Transaksi' : 'Bonus Barang' }}
                                </div>
                              </v-card-text>
                            </v-card>  
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="4" class="black--text py-0" v-if="(detail.minimum_transaksi*1) > 0">
                        <v-row>
                          <v-col cols="12" md="12">
                            <v-card
                              flat
                              style="border-radius: 10px; background-color: #FFCDD2">
                              <v-card-text>
                                <div class="black--text mb-1">
                                  Minimum Transaksi
                                </div>
                                <div class="black--text fs-20 font_weight_600 black_one">
                                  <span v-if="detail.minimum_transaksi_type === 'value'">Rp. </span> {{ (detail.minimum_transaksi*1) | number }} <span v-if="detail.minimum_transaksi_type === 'qty'">{{ detail.minimum_transaksi_unit }}</span>
                                </div>
                              </v-card-text>
                            </v-card>  
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="4" class="black--text py-0" v-if="(detail.minimum_transaksi*1) > 0">
                        <v-row>
                          <v-col cols="12" md="12">
                            <v-card
                              flat
                              style="border-radius: 10px; background-color: #C8E6C9">
                              <v-card-text>
                                <div class="black--text mb-1">
                                  Diskon {{ (detail.percent*1) > 0 ? 'Persen' : 'Nominal' }}
                                </div>
                                <div class="black--text fs-20 font_weight_600 black_one">
                                  <span v-if="(detail.percent*1) > 0">{{ detail.percent }}%</span>
                                  <span v-if="(detail.percent*1) === 0">Rp. {{ (detail.nominal*1) | number }}</span>
                                </div>
                              </v-card-text>
                            </v-card>  
                          </v-col>
                        </v-row>
                      </v-col>

                      <v-col cols="12" md="6" class="black--text py-0" v-if="(detail.bonus_qty*1) > 0">
                        <v-row>
                          <v-col cols="12" md="12">
                            <v-card
                              flat
                              style="border-radius: 10px; background-color: #C8E6C9">
                              <v-card-text>
                                <div class="black--text mb-1">
                                  Bonus Barang
                                </div>
                                <div class="black--text fs-20 font_weight_600 black_one">
                                  {{ detail.bonus_qty }} {{ detail.bonus_qty_unit }}
                                </div>
                              </v-card-text>
                            </v-card>  
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                    
                  </v-card>

                  <v-card 
                    flat
                    class="mb-5"
                    style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
                    <div class="view">
                      <div style="height: 900px; overflow-y: auto;">
                        
                        <table style="border-radius: 10px; width: 100%;" class="table">
                          <tr>
                            <th style="z-index: 2; position: sticky; top: 0; background-color: white !important; font-size: 12px; border: 1px solid #ededed; border-left: none; width: 60px; min-width: 60px; max-width: 60px; padding: 8px 12px; text-align: center;">No</th>
                            <th style="z-index: 2; position: sticky; top: 0; background-color: white !important; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                              Nama Toko
                            </th>
                            <th style="z-index: 2; position: sticky; top: 0; background-color: white !important; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                              Nama Customer
                            </th>
                          </tr>
                          <tr v-for="(item, index) in detail.promo_store" :key="index">
                            <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 80px; min-width: 80px; max-width: 80px; padding: 8px 12px; text-align: center;">
                              {{ index+1 }}
                            </td>
                            <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">
                              {{ item.store_name }}
                            </td>
                            <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 100%; text-align: left;">
                              {{ item.customer_name }}
                            </td>
                          </tr>
                        </table>
                      </div>
                    </div>
                  </v-card>
                </v-card-text>
              </v-card>

            </v-col>
          </v-row>

          <v-row
            justify="end"
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              md="12"
              class="d-flex align-center justify-end py-0">
              
              <v-btn
                to="/promo/data"
                color="red"
                elevation="0"
                width="140"
                height="45"
                class="body-2 white--text text-capitalize d-flex align-center ml-4 border-radius"
                style="font-weight: 600;">
              
                  Kembali
              </v-btn>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        approved_by: [],
        approved_reason: '',
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        menu: false,
        modal: false,
        menu2: false,
        
        zoomed: false,
        zoomedTtd: false,
        imageAspectRatio: 1,
        imageAspectRatioTtd: 1,
        lastIndex: 1,

        dialog: {
          status: false,
          pembayaran: false,
        },

        order_list: {},
        status: '',

        detail: {},

        rejected_reason: '',
        bank: [],

        form: {
          id: '',
          bpb_arr: [],
          payment_method: 'Tunai',
          payment_bank_name: '',
          payment_rek_number: '',
        },
        headers_data: [
          {
            text: 'No',
            width: '80',
            value: 'index',
            freeze: true,
            hide: false
          },
          {
            text: 'Nama',
            width: '100%',
            value: 'varian_name',
            freeze: true,
            hide: false
          }
        
        ],
        category: [],
        branch: [],

        mobilephone: {
          name: '',
          id: ''
        },

        upload: {
          ttd: null,
          image_url: null
        },
        total_nominal: 0,

        process: {
          form: false,

          load: false,

          image_url: false
        },
        
        message: {
          success: '',
          error: '',
          status: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue')
    },
    watch: {
      
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },
      configHeaders () {
        return this.headers_data.filter(header => !header.hide)  
      },
    },
    mounted () {
      this.fetchDetail()
    },
    methods: {
      async fetchDetail () {
        this.process.load = true
        let params = {
          id: this.$route.params.id
        }

        await get('admin/promo/detail', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.detail = res.results.data
          }
          this.process.load = false
        })
      },
      reset (index) {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.rejected_reason = ''

        this.process.form = false

        this.message.error = ''
      },
      onImageLoad(e) {
        const img = e.target
        this.imageAspectRatio = img.naturalWidth / img.naturalHeight
      },
      onImageLoadAkta(e) {
        const img = e.target
        this.imageAspectRatioAkta = img.naturalWidth / img.naturalHeight
      },

      addFreezes () {
        this.removeFreezes()

        this.selected.freeze = []

        for (let i = 0; i < this.configHeaders.length; i++) {
          if (this.configHeaders[i].freeze) {
            // ADD TO SELECTOR
            this.selected.freeze.push({
              child: i + (this.checkbox ? 2 : 1),
              width: this.configHeaders[i].width.split('px')[0]
            })

            // LOOP STYLESHEET
            for (let f = 0; f < this.selected.freeze.length; f++) {
              let style = document.createElement('style'),
                  width = 0

              if (this.checkbox) {
                width = f < 1 ? '65' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
              } else {
                width = f < 1 ? '0' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
              }

              // ADD STYLESHET TO FREEZE
              style.innerHTML = `
                .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 5;
                  background: #FFFFFF;
                }

                .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 1;
                }
              `

              // ADD TO APPENDCHILD
              document.head.appendChild(style)
            }
          }
        }
      },
      removeFreezes () {
        // LOOP STYLESHEET
        for (let f = 0; f < this.selected.freeze.length; f++) {
          let style = document.createElement('style')
          
          // RESET STYLESHEET TO AUTO
          style.innerHTML = `
            .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
              background: #FFFFFF;
            }

            .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
            }
          `

          // ADD TO APPENDCHILD
          document.head.appendChild(style)
        }
      },
      addHides () {
        if (this.headers.length < 6) this.getTableToResize()
      },
      getTableToResize () {
        let tables = document.getElementsByTagName('table')

        for (let i = 0; i < tables.length; i++) {
          this.resizableGrid(tables[i])
        }
      },
      resizableGrid (table) {
        let row = table.getElementsByTagName('tr')[0],
            cols = row ? row.children : undefined
        
        if (!cols) return
        
        table.style.overflow = 'hidden'
        
        let tableHeight = table.offsetHeight
        
        for (let i = 0; i < cols.length; i++) {
          let div = createDiv(tableHeight)
          cols[i].appendChild(div)
          cols[i].style.position = 'relative'

          setListeners(div)
        }

        function setListeners (div) {
          let pageX, curCol, nxtCol, curColWidth, nxtColWidth

          div.addEventListener('mousedown', e => {
            curCol = e.target.parentElement
            nxtCol = curCol.nextElementSibling
            pageX = e.pageX
            
            let padding = paddingDiff(curCol)
            
            curColWidth = curCol.offsetWidth - padding

            if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
          })

          div.addEventListener ('mouseover', e => {
            e.target.style.borderRight = '2px solid #e0e0e0'
          })

          div.addEventListener ('mouseout', e => {
            e.target.style.borderRight = ''
          })

          document.addEventListener ('mousemove', e => {
            if (curCol) {
              let diffX = e.pageX - pageX
          
              if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'

              curCol.style.width = (curColWidth + diffX)+'px'
            }
          })

          document.addEventListener ('mouseup', () => { 
            curCol = undefined
            nxtCol = undefined
            pageX = undefined
            nxtColWidth = undefined
            curColWidth = undefined
          })
        }

        function createDiv (height) {
          let div = document.createElement('div')

          div.style.top = 0
          div.style.right = 0
          div.style.width = '1px'
          div.style.position = 'absolute'
          div.style.cursor = 'col-resize'
          div.style.userSelect = 'none'
          div.style.height = height + 'px'
          div.style.background = '#e0e0e0'

          return div
        }

        function paddingDiff (col) {
          if (getStyleVal(col,'box-sizing') == 'border-box') {
            return 0
          }
          
          let padLeft = getStyleVal(col,'padding-left')
          let padRight = getStyleVal(col,'padding-right')

          return (parseInt(padLeft) + parseInt(padRight))
        }

        function getStyleVal (elm,css) {
          return (window.getComputedStyle(elm, null).getPropertyValue(css))
        }
      },

      async save () {
        this.message.error = ''
        const isValid = true
        if (isValid) {
          

        this.process.form = true
        let form = {
          invoice_id: this.detail.id,
          payment_method: this.form.payment_method,
          payment_bank_name: this.form.payment_method === 'Tunai' ? '' : this.form.bank.name,
          payment_rek_number: this.form.payment_method === 'Tunai' ? '' : this.form.bank.rek_number
        }

        let url = 'admin/customer_invoice/payment'

        await post(url, {
          data: form
        }).then(response => {
          let res = response.data

          this.process.form = false

          if (res.status === 200) {

            this.dialog.pembayaran = false

            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetchDetail()
          } else {
            this.message.error = res.message
          }
        })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }

        
      }
    }
  }
</script>

<style>
  table, th, td {
    /* border: 1px solid #ededed;
    border-collapse: collapse; */
    /* border: thin ridge black; */
    border-spacing: 4px;
    border-collapse: collapse;
    border: 1px solid #ededed;
    padding: 10px;
  }


.view {
  margin: auto;
  /* width: 100%; */
}

/* .wrapper { 
  overflow-y: auto; 
  height: calc(100vh - 300px); 
} 

.wrapper-none { 
  /* overflow-y: auto; 
  height: calc(100vh - 270px);  */
/* }  */

.wrapper th { 
  position: sticky; 
  top: 0; 
  background-color: white !important;
}  */
.sticky-col {
  position: -webkit-sticky;
  position: sticky;
  background-color: white !important;
}

.one-col {
  width: 60px;
  min-width: 60px;
  max-width: 60px;
  left: 0px;
}

.second-col {
  width: 150px;
  min-width: 150px;
  max-width: 150px;
  left: 150px;
}

.three-col {
  width: 150px;
  min-width: 150px;
  max-width: 150px;
  left: 300px;
}

.four-col {
  width: 200px;
  min-width: 200px;
  max-width: 200px;
  left: 450px;
}

tr:hover {background-color: #1976d236;}
tr.selected {background-color: #1976d236;}
</style>